import React from 'react'

import { Router, Route, Link, withRouter, Redirect} from 'react-router-dom';
import {Button, Col, Input, InputGroup, InputGroupAddon, Table} from 'reactstrap'
import SearchIcon from 'react-icons/lib/fa/search'
import ClearIcon from 'react-icons/lib/fa/close'
import SortAscendingIcon from 'react-icons/lib/fa/sort-asc'
import SortDescendingIcon from 'react-icons/lib/fa/sort-desc'
import YesIcon from 'react-icons/lib/fa/check-circle'
import NoIcon from 'react-icons/lib/fa/times-circle'


import '../../stylesheets/ModelListTable.css'

const titleCasePropertyName = (prop) => {
    let unCamelCased = prop.replace(/([A-Z])/g, (s) => "-" + s.toLowerCase())
    let parts = unCamelCased.split(/[-|_]/).map(p => p.charAt(0).toUpperCase() + p.slice(1))
    return parts.join(" ").trim()
}

let tableCellContentForValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    } else if (typeof(value) === 'string' || value instanceof String) {
        return value
    } else if (typeof(value) == typeof(true)) {
        return (value ? <YesIcon className="text-success"/> : <NoIcon className="text-danger"/>)
    } else if (value instanceof Array || value.length) {
        return value.length
    } else {
        // assume string and hope for the best
        return value
    }
}

let tableCellKeyForValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    } else if (typeof(value) === 'string' || value instanceof String) {
        return value
    } else if (typeof(value) == typeof(true)) {
        return (value ? 'true' : 'false')
    } else if (value instanceof Array || value.length) {
        return value.length
    } else {
        // assume string and hope for the best
        return value
    }
}

let tableCellStyleForWidths = function(width) {
    if (!width) {
        return {}
    } else if (width && !width.length || width.length < 2) {
        return {width: width*16}
    }  else if (window.innerWidth < 720) {
        return {width: width[0]*16}
    } else {
        return {width: width[1]*16}
    }
};


class ModelListTable extends React.Component {
    constructor(props) {
        super(props)
        const {fields, boldFields, searchFields, history, hideableFields, models, selected, selectable, clickable, actionName, onSelectedChange, onRowClick, leftAlignFields, rightAlignFields, fixedCharacterWidthFields, fieldContentGenerators, className, searchParam, onSearch} = props
        this.history = history
        let alignmentModel = {}
        fields.filter(f => !(fieldContentGenerators || {}).hasOwnProperty(f)).map(f => alignmentModel[f] = '')
        this.state = {
            fields: fields || [],
            searchParam:searchParam,
            boldFields: boldFields || [],
            searchFields: searchFields || [],
            hideableFields: hideableFields || [],
            models: models || [],
            alignmentModel,
            fixedCharacterWidthFields: fixedCharacterWidthFields || {}, // key-value list of {fieldName: WIDTH_IN_CHARS}
            fieldContentGenerators: fieldContentGenerators || {},  // key-value list of {fieldName: functionToGenerateContent(model)}
            selectable,
            clickable,
            actionName: actionName || '',
            className: className || '',
            filteredModels: models || [],
            unsortedFilteredModels: models || [],
            unsortedModels: models || [],
            leftAlignFields: leftAlignFields || [],
            rightAlignFields: rightAlignFields || [],
            sortBy: null,
            sortDescending: false,
            searchText: null,
            selected: selected || [],
        }

        this.onSelectedChange = onSelectedChange || (() => {
        })
	this.onSearch = onSearch || null
        this.onRowClick = onRowClick || (() => {
        })
        this.searchByText = this.searchByText.bind(this)
        this.handleInput1Change = this.handleInput1Change.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.sortBy = this.sortBy.bind(this)
        this.onSelectModel = this.onSelectModel.bind(this)
    }

    componentDidMount() {
        window.onresize = function () {
            this.forceUpdate()
        }.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let {fields, boldFields, searchFields, hideableFields, models, search, selectable, clickable, selected, actionName, onSelectedChange, onRowClick, fixedCharacterWidthFields, fieldContentGenerators, className, leftAlignFields, rightAlignFields} = nextProps
        let {filteredModels, alignmentModel, unsortedFilteredModels, unsortedModels, searchText, sortBy, sortDescending} = this.state
        if (models && models !== this.state.models) {
            filteredModels = models || filteredModels || []
            unsortedFilteredModels = models || this.state.unsortedFilteredModels || []
            unsortedModels = models || this.state.unsortedModels
            searchText = null
            sortBy = null
            sortDescending = false
        } else {
            selected = this.state.selected || []
        }

        if (unsortedModels && fields) {
            let alignmentModel = {}
            fields.filter(f => !(fieldContentGenerators || {}).hasOwnProperty(f)).map(f => {
                unsortedModels.map(m => {
                    if (!alignmentModel.hasOwnProperty(f)) {
                        alignmentModel[f] = `${m[f] || ''}`
                    } else if (alignmentModel[f].length < `${m[f] || ''}`.length) {
                        alignmentModel[f] = `${m[f]}`
                    }
                })
            })
        }

        this.setState({
            fields: fields || [],
            boldFields: boldFields || [],
            searchFields: searchFields || [],
            hideableFields: hideableFields || [],
            leftAlignFields: leftAlignFields || [],
            rightAlignFields: rightAlignFields || [],
            fixedCharacterWidthFields: fixedCharacterWidthFields || {}, // key-value list of [{fieldName: WIDTH_IN_CHARS}.]
            fieldContentGenerators: fieldContentGenerators || {},  // key-value list of [{fieldName: functionToGenerateContent(model)}.]
            selectable,
            clickable,
            actionName: actionName || '',
            className: className || '',
            models,
            filteredModels,
            unsortedFilteredModels,
            unsortedModels,
            alignmentModel,
            searchText,
            sortBy,
            sortDescending,
            selected,
            search
        })

        this.onSelectedChange = onSelectedChange || (() => {
        })
        this.onRowClick = onRowClick || (() => {
        })
    }
    /* Set the searchtext value after getting from the input field
    and updates the current url with new search param value*/
    searchByText(text) {
	if (this.onSearch) {
		this.onSearch(text)
		return
	}
        let {models, unsortedModels, selected, searchFields, searchText} = this.state
        if (!text || !text.length) {
            this.setState({searchText: null, filteredModels: models, unsortedFilteredModels: unsortedModels})
            return
        }
        this.state.searchText = text
        this.setState({searchText: text})
        
        if ( (window.location.pathname == '/management/controllers' )|| (window.location.href.indexOf("controllerPage") > -1) || (window.location.href.indexOf("search") > -1) ) {
            this.props.history.push(`/management/controllers?search=`+text+`&controllerPage=1`)
            window.location.reload(true)
        } else{
            let filterBySearchFields = (list) =>
            list.filter(m =>
                searchFields.map(field =>
                    String(m[field]).trim().toLowerCase().includes(text.trim().toLowerCase())
                ).includes(true)
        )
        let filteredModels = filterBySearchFields(models)
        let unsortedFilteredModels = filterBySearchFields(unsortedModels)
        if (selected && selected.length) {
            let appendSelectedToList = (list) =>
                selected.map(s => {
                    if (!list.filter(m => m.id === s).length) {
                        list.push(models.filter(m => m.id === s)[0])
                    }
                })
            appendSelectedToList(filteredModels)
            appendSelectedToList(unsortedFilteredModels)
        }
        this.setState({filteredModels, unsortedFilteredModels})
        }   
    }

    clearSearch() {
	if (this.onSearch) {
	    this.onSearch('')
	    return
	}

        let {models, unsortedModels, searchParam} = this.state
	
        if (window.location.href.indexOf("search") > -1) {
            this.props.history.push(`/management/controllers?search=&controllerPage=1`)
            this.setState({loading:true, searchParam:''})
        }else{
            this.setState({filteredModels: models, unsortedFilteredModels: unsortedModels, searchText: null, searchParam:''})
            this.searchInput.value = null
        }
    }

    sortBy(field) {
        let {unsortedFilteredModels, unsortedModels, sortBy, sortDescending} = this.state
        if (sortBy === field && sortDescending) {
            sortBy = null
            sortDescending = false
            this.setState({sortBy, sortDescending, models: unsortedModels, filteredModels: unsortedFilteredModels})
            return
        } else if (sortBy === field) {
            sortDescending = true
        } else {
            sortBy = field
            sortDescending = false
        }

        let sortByField = (list, f, desc) =>
            [...list].sort((a, b) =>
                (String(a[f]) < String(b[f]) ? -1 : (String(a[f]) > String(b[f]) ? 1 : 0)) * (desc ? -1 : 1)
            )
        let models = sortByField(unsortedModels, field, sortDescending)
        let filteredModels = sortByField(unsortedFilteredModels, field, sortDescending)
        this.setState({sortBy, sortDescending, models, filteredModels})
    }

    async onSelectModel(model) {
        console.log("selectEventHandlerForModel")
        console.log(model)
        let {selected} = this.state
        if (selected.includes(model.id)) {
            selected = selected.filter((m) => m !== model.id)
        } else {
            selected.push(model.id)
        }
        await this.setState({selected})
        await this.onSelectedChange(selected)
    }

    handleInput1Change = (e) => {
        let value = e.target.value
        if(value == '' && window.location.pathname == '/management/controllers'){
            this.setState({searchParam:''})
        this.props.history.push(`/management/controllers/?controllerPage=1&search=`)
        }
        if((value == '') && !(window.location.pathname == '/management/controllers')){
            this.setState({searchParam:''})
        }
        if(value){
            this.setState({searchParam:value})
        }
    }

    render() {
        let {className, actionName, fields, handleInput1Change, boldFields, searchParam,searchFields, hideableFields, filteredModels, sortBy,
             sortDescending, selected, selectable, searchText, clickable, fixedCharacterWidthFields, rightAlignFields,
             leftAlignFields, fieldContentGenerators, alignmentModel} = this.state
        let searchHelpText = ""
        if (searchFields && searchFields.length) {
            let searchables = searchFields.map((f) => titleCasePropertyName(f).toLowerCase())
            let seperator = searchables.length > 2 ? ", " : " "
            searchables[searchables.length - 1] = searchables.length > 1 ? "or " + searchables[searchables.length - 1] : searchables[searchables.length - 1]
            searchHelpText = `Search by ${searchables.join(seperator)}...`
        }
        return <Col xs={12} className={"no-gutters model-list-table-control-container " + className}>
            {searchFields && searchFields.length && searchParam == ''?
                <InputGroup>
                    <Input placeholder={searchHelpText}  innerRef={i => this.searchInput = i} onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this.searchByText(this.searchInput.value)
                        }
                        
                    }}/>
            
                    {searchText && searchText.length  ?
                        <InputGroupAddon addonType="append">
                            <Button color="danger" onClick={this.clearSearch}>
                                <ClearIcon/>
                            </Button>
                        </InputGroupAddon> :
                        null}
                    <InputGroupAddon addonType="append">
                        <Button color="secondary" value ="" onClick={() => {
                            this.searchByText(this.searchInput.value)
                        }}>
                            <SearchIcon/>
                        </Button>
                    </InputGroupAddon>
                </InputGroup> :
                null}
            {searchFields && searchFields.length && searchParam!=''?
                <InputGroup>
                    <Input placeholder={searchHelpText}  onChange={this.handleInput1Change} value ={searchParam} innerRef={i => this.searchInput = i} onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this.searchByText(this.searchInput.value)
                        }
                        
                    }}/>
            
                    {searchParam && searchParam.length ?
                        <InputGroupAddon addonType="append">
                            <Button color="danger" onClick={this.clearSearch}>
                                <ClearIcon/>
                            </Button>
                        </InputGroupAddon> :
                        null}
                    <InputGroupAddon addonType="append">
                        <Button color="secondary" value ="" onClick={() => {
                            this.searchByText(this.searchInput.value)
                        }}>
                            <SearchIcon/>
                        </Button>
                    </InputGroupAddon>
                </InputGroup> :
                null}            

            <Table className="model-list-table mb-0">
                <thead>
                <tr>
                    {selectable ?
                        <td className="action-head" width="100">
                            {actionName}
                        </td> :
                        null}

                    {fields.map((f, idx) =>
                        <td onClick={() => {fieldContentGenerators.hasOwnProperty(f) ? void(0) : this.sortBy(f)}}
                            key={`field-thtd-${idx}-${f}`}
                            className={(hideableFields.includes(f) ? "d-none d-md-table-cell " : "") +
                                        (rightAlignFields.includes(f) ? "text-right " : "") +
                                        (leftAlignFields.includes(f) ? "text-left " : "") +
                                        (fieldContentGenerators.hasOwnProperty(f) ? "generated " : "")}
                            style={tableCellStyleForWidths(fixedCharacterWidthFields[f])}>
                            {sortBy === f ?
                                <span className="light-sf-blue">
                                            {sortDescending ?
                                                <SortAscendingIcon className="asc mr-1"/> :
                                                <SortDescendingIcon className="desc mr-1"/>}
                                    {titleCasePropertyName(f)}
                                        </span> :
                                titleCasePropertyName(f)}
                        </td>)}
                </tr>
                </thead>
                <tbody className="d-none">
                    <tr>
                        {selectable ?
                            <td width="100">
                                <input type="checkbox" value={false}/>
                            </td> :
                            null}
                        {fields.map((f, fidx) => {
                            let content = tableCellContentForValue(alignmentModel[f])
                            let key = tableCellKeyForValue(alignmentModel[f])
                            return <td key={`field-td-hidden-${fidx}-alignment-${key}`}
                                title={key}
                                className={(hideableFields.includes(f) ? "d-none d-md-table-cell " : "") +
                                            (rightAlignFields.includes(f) ? "text-right " : "") +
                                            (leftAlignFields.includes(f) ? "text-left " : "")}
                                style={tableCellStyleForWidths(fixedCharacterWidthFields[f])}>
                                {boldFields.includes(f) ?
                                    <strong>{content}</strong> :
                                    content}
                            </td>})}
                    </tr>
                {!filteredModels || !filteredModels.length ?
                    <tr>
                        <td colSpan={30} align="center">
                            {searchText && searchText.length ?
                                "No Results" :
                                "No Data"}
                        </td>
                    </tr> :
                    null}
                </tbody>
            </Table>
            <Col xs={12} className="no-gutters model-list-table-container">
                <Table className="model-list-table">
                    <thead className="d-none">
                    <tr>
                        {selectable ?
                            <td className="action-head" width="100">
                                {actionName}
                            </td> :
                            null}

                        {fields.map((f, idx) =>
                            <td key={`field-thtd-hidden-${idx}-${f}`}
                                className={(hideableFields.includes(f) ? "d-none d-md-table-cell " : "") +
                                            (rightAlignFields.includes(f) ? "text-right " : "") +
                                            (leftAlignFields.includes(f) ? "text-left " : "")}
                               style={tableCellStyleForWidths(fixedCharacterWidthFields[f])}>
                                {sortBy === f ?
                                    <span className="light-sf-blue">
                                            {sortDescending ?
                                                <SortAscendingIcon className="asc mr-1"/> :
                                                <SortDescendingIcon className="desc mr-1"/>}
                                        {titleCasePropertyName(f)}
                                        </span> :
                                    titleCasePropertyName(f)}
                            </td>)}
                    </tr>
                    </thead>
                    <tbody>
                    {filteredModels.map((m, idx) =>
                        <tr onClick={(e) => {clickable ? this.onRowClick(e,m) : void(0)}}
                            className={(selected && selected.includes(m.id) ? "selected " : "")}
                            key={`model-tr-${idx}-${m.id}`}>
                            {selectable ?
                                <td key={`action-td-${idx}-${m.id}`} width="100">
                                    <input type="checkbox" value={selected && selected.includes(m.id)}
                                           checked={selected && selected.includes(m.id)}
                                           onChange={() => this.onSelectModel(m)}/>
                                </td> :
                                null}
                            {fields.map((f, fidx) => {
                                let content = tableCellContentForValue(m[f])
                                let key = tableCellKeyForValue(m[f])
                                return <td key={`field-td-hidden-${idx}-${fidx}-${m.id}-${key}`}
                                           title={key}
                                           className={(hideableFields.includes(f) ? "d-none d-md-table-cell " : "") +
                                           (rightAlignFields.includes(f) ? "text-right " : "") +
                                           (leftAlignFields.includes(f) ? "text-left " : "")}
                                           style={tableCellStyleForWidths(fixedCharacterWidthFields[f])}>
                                    {fieldContentGenerators.hasOwnProperty(f) ?
                                        fieldContentGenerators[f](m):
                                        (boldFields.includes(f) ?
                                            <strong>{content}</strong> :
                                            content)}
                                </td>})}
                        </tr>)}
                    {!filteredModels || !filteredModels.length ?
                        <tr>
                            <td colSpan={30} align="center">
                                {searchText && searchText.length ?
                                    "No Results" :
                                    "No Data"}
                            </td>
                        </tr> :
                        null}
                    </tbody>
                </Table>
            </Col>
        </Col>
    }
}

export default withRouter(ModelListTable);



// WEBPACK FOOTER //
// ./src/components/ui/ModelListTable.js